import { Box } from "@mui/material";
import DatePeriodSelector from "./DatePeriodSelector.jsx";

export default function ToolbarDatePeriod({
  value,
  onChange,
  showTitle,
  showCustom,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
      }}
    >
      <DatePeriodSelector
        value={value}
        onChange={onChange}
        showTitle={showTitle}
        allowCustom={showCustom}
      />
    </Box>
  );
}
